import React from 'react'
import { observer } from 'mobx-react-lite'
import { addYears } from 'date-fns'

import { DatePickerCell } from './DatePickerCell'

import { useLogic } from '../../../hooks/storeHook'

import { dateUtils, tryFromUnixTime } from '../../../common/dateTimeUtility'

import { MyRowProps } from '../../../types/tableTypes'
import { UserModel } from '../../../server/mpsklad_core/Models/UserModel'

export const SubscriptionEndDateCell =
  observer(
    ({row}: MyRowProps<UserModel>) => {
      const {setUserSubscriptionEndDate} = useLogic()

      const onDateChange =
        async (newDate: Date | null) => {
          try {
            await setUserSubscriptionEndDate(row.id, newDate)
          } catch (e) {
            console.log('Failed to change subscription end date', e)
          }
        }

      return (
        <DatePickerCell
          value={tryFromUnixTime(row.subscriptionEndDate) ?? null}
          minDate={addYears(dateUtils.now, -2)}
          maxDate={addYears(dateUtils.now, 1)}
          onChange={onDateChange}
        />
      )
    })